import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=0d123584&lang=postcss&scoped=true"
script.__scopeId = "data-v-0d123584"

export default script